import React from 'react'

type IconProps = {
  size?: number
  className?: string
}

export default function PapyrusIcon({ size = 20, className }: IconProps) {
  return (
    <img
      src="/images/icons/papyrus.png"
      alt="Papyrus SDK"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain', borderRadius: 4 }}
    />
  )
}
